var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('Form',{ref:"form",on:{"refresh":_vm.onRefresh,"active_change":_vm.onActiveChange}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }